import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeroMessages } from './Hero.messages';
import { LiveDemo } from './LiveDemo';

interface HeroProps {
  onStartTranslating: () => void;
  onSeeHow: () => void;
}

export const Hero: React.FC<HeroProps> = ({ onStartTranslating, onSeeHow }) => {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-pattern"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            {t(HeroMessages.TITLE)}
          </h1>
          
          <p className="hero-subtitle">
            {t(HeroMessages.SUBTITLE)}
          </p>
          
          <div className="hero-proof">
            <span className="proof-item">{t(HeroMessages.PROOF_JOBS_FINISH)}</span>
            <span className="proof-separator">•</span>
            <span className="proof-item">{t(HeroMessages.PROOF_TRANSLATIONS_MIN)}</span>
            <span className="proof-separator">•</span>
            <span className="proof-item">{t(HeroMessages.PROOF_NO_SUBSCRIPTIONS)}</span>
          </div>
          
          <div className="hero-ctas">
            <button 
              className="btn btn-primary btn-large"
              onClick={onStartTranslating}
              aria-label={t(HeroMessages.BTN_START_TRANSLATING_ARIA)}
            >
              {t(HeroMessages.BTN_START_TRANSLATING)}
            </button>
            <button
              className="btn btn-outline btn-large"
              onClick={onSeeHow}
              aria-label={t(HeroMessages.BTN_SEE_HOW_ARIA)}
            >
              {t(HeroMessages.BTN_SEE_HOW)}
            </button>
          </div>

          <p className="hero-note">{t(HeroMessages.NO_CARD_REQUIRED)}</p>

          <LiveDemo />
        </div>
      </div>
    </section>
  );
};
